module.exports = __webpack_public_path__ + "img/example-02-processed.74f8321c.png";